import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { TenderContextService } from '../../../services/compiling/state/tender-context.service';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';

@Component({
  selector: 'lib-question-instructions-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonModule,
    DialogModule,
    TextareaModule,
    FormsModule,
    TooltipModule,
  ],
  template: `
    <p-button
      icon="pi pi-comment"
      severity="secondary"
      size="small"
      [text]="true"
      [outlined]="hasInstructions()"
      [pTooltip]="
        hasInstructions()
          ? 'Modifica istruzioni per valutazione AI'
          : 'Aggiungi istruzioni per valutazione AI'
      "
      tooltipPosition="top"
      (onClick)="open()"
    />

    <p-dialog
      header="Istruzioni per valutazione AI"
      [visible]="dialogVisible()"
      (visibleChange)="dialogVisible.set($event)"
      [modal]="true"
      [style]="{ width: '520px' }"
      [draggable]="false"
    >
      <div class="flex flex-col gap-3">
        <p class="m-0 text-sm text-gray-500">
          Specifica istruzioni personalizzate che verranno considerate dall'AI
          durante la valutazione di questa domanda.
        </p>
        <textarea
          pTextarea
          [rows]="6"
          class="w-full resize-none"
          [(ngModel)]="draftValue"
          placeholder="Es: Fai riferimento a questo allegato..."
          autoResize="false"
        ></textarea>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
          <p-button
            label="Annulla"
            severity="secondary"
            [text]="true"
            (onClick)="cancel()"
          />
          <p-button label="Salva" (onClick)="saveInstructions()" />
        </div>
      </ng-template>
    </p-dialog>
  `,
})
export class QuestionInstructionsButtonComponent {
  private readonly widgetService = inject(CompilingWidgetService);
  private readonly tenderContext = inject(TenderContextService);

  protected readonly dialogVisible = signal(false);
  protected draftValue = '';

  protected readonly hasInstructions = computed(() => {
    const widgetId = this.widgetService.uniqueId;
    if (!widgetId) return false;
    return !!this.tenderContext.questionInstructions()[widgetId];
  });

  protected open(): void {
    const widgetId = this.widgetService.uniqueId;
    this.draftValue = widgetId
      ? (this.tenderContext.questionInstructions()[widgetId] ?? '')
      : '';
    this.dialogVisible.set(true);
  }

  protected cancel(): void {
    this.dialogVisible.set(false);
  }

  protected saveInstructions(): void {
    const widgetId = this.widgetService.uniqueId;
    if (!widgetId) return;

    const trimmed = this.draftValue.trim();
    this.tenderContext.questionInstructions.update((current) => {
      const updated = { ...current };
      if (trimmed) {
        updated[widgetId] = trimmed;
      } else {
        delete updated[widgetId];
      }
      return updated;
    });
    this.dialogVisible.set(false);
  }
}
